import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    blockHeading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    blockHeading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    blockHeading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`
  }
}
